<script setup>
import {ref, inject} from "vue";
import searchService from "@/services/search.service";
import PrimaryButton from "@/components/ui/PrimaryButton.vue";
import VueMultiselect from "vue-multiselect";

const showModal = ref(false);
const gridParams = inject('gridParams');
const queryText = inject('queryText');

const prompt = ref("You will receive two inputs:\n" +
    "  A list of companies. Each company has fields: id, name, and domain.\n" +
    "  A user's search query, describing the topic, need, or intent.\n" +
    "Your task is to carefully analyze each company in the list and determine whether it is relevant to the user's search query or not. For each company, respond with:\n" +
    "  The company's id, name, and domain\n" +
    "  Yes (relevant) or No (not relevant)\n" +
    "  A 1-2 sentence explanation for your decision\n" +
    "At the end, provide a summary with the percentage and count of relevant vs. non-relevant companies\n" +
    "Provide response in html table format."
);

const models = [
    'text-davinci-003',
    'gpt-3.5-turbo',
    'gpt-4',
    'gpt-4-turbo',
    'gpt-4o',
    'gpt-4o-mini',
    'gpt-4.1-mini',
    'gpt-4.1-nano',
];

const result = ref("");
const loading = ref(false);
const model = ref('gpt-4-turbo');

function open() {
    result.value = "";
    showModal.value = true;
}

async function submit() {
    loading.value = true;

    const {data} = await searchService.analyseResults(gridParams.value.selectedRows, prompt.value, queryText.value, model.value);
    result.value = data;
    loading.value = false;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal-w-xxl startups-ai-analysis" title="Startups AI Analysis">
        User query: <i>{{queryText}}</i>

        <VueMultiselect
            :options="models"
            v-model="model"
            :placeholder="'Select model'"
            class="mt-2 mb-2"
        />

        <textarea
            v-model="prompt"
            rows="10"
            class="form-control"
        />

        <div v-html="result"/>

        <template #modal-footer>
            <PrimaryButton
                caption="Submit"
                :loading="loading"
                loading-caption="Loading..."
                @click="submit"
            />
        </template>
    </b-modal>
</template>

<style>

.startups-ai-analysis table {
    margin-top: 10px;
}

.startups-ai-analysis td {
    padding: 5px;
}

</style>
